import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export function AppNav() {
  const loc = useLocation();
  const nav = useNavigate();
  const [me, setMe] = useState<{ email: string } | null>(null);

  useEffect(() => {
    api.me().then(({ user }) => {
      if (!user) nav('/login'); else setMe(user);
    });
  }, [nav]);

  const item = (path: string, label: string) => (
    <Link to={path} style={{
      padding: '6px 12px', borderRadius: 6, fontSize: 13, textDecoration: 'none',
      color: loc.pathname === path ? '#0ea5e9' : '#475569',
      fontWeight: loc.pathname === path ? 600 : 400,
      background: loc.pathname === path ? '#0ea5e91a' : 'transparent',
    }}>{label}</Link>
  );

  async function logout() {
    await api.logout();
    nav('/login');
  }

  return (
    <nav style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '12px 24px', borderBottom: '1px solid #e2e8f0', background: 'white' }}>
      {item('/', 'Geoportales')}
      {item('/sources', 'Fuentes de datos')}
      {item('/users', 'Usuarios')}
      <span style={{ marginLeft: 'auto', fontSize: 12, color: '#64748b' }}>{me?.email}</span>
      <button onClick={logout} style={{ marginLeft: 8, fontSize: 12, padding: '4px 8px', background: 'transparent', border: '1px solid #cbd5e1', borderRadius: 4, cursor: 'pointer' }}>Salir</button>
    </nav>
  );
}
